module.exports = __webpack_public_path__ + "static/media/notifications.d1f9746a.svg";